import Bugsnag from '@bugsnag/js';
import { createLobbyChatOutbound } from '../api/outbound/lobbyOutbounds';
import { createMttStagingChatOutbound } from '../api/outbound/mttStagingOutbounds';
import { createLegacySetAvatarNumberOutbound, createPokerChatOutbound } from '../api/outbound/pokerOutbounds';
import { thunkToggleDebugPanel } from '../redux/actions/panelsActions';
import { ALL_BOMB_PROPERTIES } from '../types/bombTypes';
import { throwBomb } from './bombUtils';
const BOMB_TYPES = Object.values(ALL_BOMB_PROPERTIES).map(({ bombType }) => bombType);
/**
 * Returns whether this handler handled the message itself.
 * (If true, the caller should take no further action.)
 */
function commonChatInputHandler(socketSend, message, dispatch) {
    if (message === '/debug') {
        dispatch(thunkToggleDebugPanel(socketSend));
        return true;
    }
    if (message === '/test-error') {
        // Simulate a JavaScript runtime error on demand, for example to test that sourcemaps are in effect when the error is reported to bugsnag.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const object = {};
        console.log(object.nonexistent['test-error-reference']); // throws an error
        return true;
    }
    if (message === '/test-bugsnag') {
        console.warn('Sending test error to bugsnag...');
        Bugsnag.notify(new Error('testing bugsnag'));
        return true;
    }
    return false;
}
function bombChatInputHandler(socketSend, message) {
    // collapse any repeated spaces into single spaces:
    message = message.replace(/ +/g, ' ');
    for (const bombType of BOMB_TYPES) {
        if (message.startsWith(`/${bombType} `)) {
            const parts = message.split(' ');
            if (parts.length === 2) {
                const [, targetUsername] = parts;
                throwBomb({ targetUsername, bombType, socketSend, uiControlType: 'chat message' });
            }
            else if (parts.length >= 3) {
                const [, targetUsername, numberOfBombsStr] = parts;
                const numberOfBombs = Number(numberOfBombsStr);
                throwBomb({
                    targetUsername,
                    bombType,
                    socketSend,
                    uiControlType: 'chat message',
                    numberOfBombs: !isNaN(numberOfBombs) ? numberOfBombs : undefined
                });
            }
            return true;
        }
    }
    return false;
}
export function pokerChatInputHandler(socketSend, message, dispatch) {
    if (message.startsWith('/')) {
        if (commonChatInputHandler(socketSend, message, dispatch)) {
            return;
        }
        if (bombChatInputHandler(socketSend, message)) {
            return;
        }
        if (message.startsWith('/legacy-avatar ')) {
            const legacyAvatarNumber = Number(message.substring(message.indexOf(' ') + 1));
            if (!isNaN(legacyAvatarNumber)) {
                socketSend(createLegacySetAvatarNumberOutbound(legacyAvatarNumber));
            }
            return;
        }
    }
    socketSend(createPokerChatOutbound(message));
}
export function mttStagingChatInputHandler(socketSend, message, dispatch) {
    if (message.startsWith('/')) {
        if (commonChatInputHandler(socketSend, message, dispatch)) {
            return;
        }
    }
    socketSend(createMttStagingChatOutbound(message));
}
export function lobbyChatInputHandler(socketSend, message, dispatch) {
    if (message.startsWith('/')) {
        if (commonChatInputHandler(socketSend, message, dispatch)) {
            return;
        }
    }
    socketSend(createLobbyChatOutbound(message));
}
